import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';
import EvaluationModal from "./partials/EvaluationModal";
import SearchAnonymousExamRecord from "./partials/SearchAnonymousExamRecord";

import ExportPDFPro from "./partials/ExportPDFPro"; 
import FichePreviewModal from "./partials/AnonymousExamRecordPreviewModal";

import { pdf } from "@react-pdf/renderer"; // 🔹 Ajouter cette ligne
import MultipleFichesPDF from "./partials/MultipleFichesPDF";

import ResultatsPharmaciePDF, { generatePDF } from "./partials/ResultatsPharmaciePDF";
import { PDFViewer } from "@react-pdf/renderer";

import { format } from "date-fns";
import { fr } from "date-fns/locale";






import {
    getAnonymousExamRecords as onGetAnonymousExamRecords,
    addNewAnonymousExamRecord as onAddNewAnonymousExamRecord,
    updateAnonymousExamRecord as onUpdateAnonymousExamRecord,
    deleteAnonymousExamRecord as onDeleteAnonymousExamRecord,
    getSemesters as onGetSemesters,
    getCourseUnits as onGetCourseUnits,
    resetEvaluationLastActionSuccess as OnResetEvaluationLastActionSuccess,

    generateAnonymousRecords as onGenerateAnonymousRecords
    
} from "store/actions";

import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import { Col, Row, Card, CardBody, UncontrolledTooltip, Button } from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link, useParams } from "react-router-dom";

const AnonymousExamRecord = () => {
    document.title = "Fiches anonymes | CinzanEdu";

    const dispatch = useDispatch();
    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [evaluation, setEvaluation] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);

    const [selectedRecord, setSelectedRecord] = useState(null);
const [modalOpen, setModalOpen] = useState(false);

const [previewModalOpen, setPreviewModalOpen] = useState(false);
const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);



const { evaluationUuid } = useParams();



    // 🔹 Nouveau state pour stocker les filtres de recherche
    const [filters, setFilters] = useState({});

    // Selector Anonymous exam record
    const AnonymousExamRecordProperties = createSelector(
        (state) => state.anonymousExamRecordReducer, 
        (anonymousExamRecordReducer) => ({
            anonymousExamRecords: anonymousExamRecordReducer.anonymousExamRecords,
            loading: anonymousExamRecordReducer.loading,
            lastActionSuccess: anonymousExamRecordReducer.lastActionSuccess
        })
    );

    const { anonymousExamRecords, loading, lastActionSuccess } = useSelector(AnonymousExamRecordProperties);
    const [isLoading, setLoading] = useState(true);



    // Selector Semester
    const SemesterProperties = createSelector(
        (state) => state.semesterReducer, 
        (semesterReducer) => ({
            semesters: semesterReducer.semesters,
        })
    );

    const { semesters } = useSelector(SemesterProperties);

    console.log("EVALUATION UUID: ", evaluationUuid);

    // Selector Course Unit
    const CourseUnitProperties = createSelector(
        (state) => state.courseUnitReducer, 
        (courseUnitReducer) => ({
            courseUnits: courseUnitReducer.courseUnits,
        })
    );

    const { courseUnits } = useSelector(CourseUnitProperties);

    // 🔹 Fetch initial une seule fois
    /*useEffect(() => {
        dispatch(onGetAnonymousExamRecords());
    }, [dispatch]);
    */
    useEffect(() => {
        if (evaluationUuid) {
            dispatch(onGetAnonymousExamRecords({ evaluation_uuid: evaluationUuid }));
        }
    }, [dispatch, evaluationUuid]); // 👈 Ajoute evaluationUuid ici

    // 🔹 Ferme le modal après succès
    useEffect(() => {
        if (lastActionSuccess && modal) {
            toggle();
            setEvaluation(null);
            dispatch(OnResetEvaluationLastActionSuccess());
        }
    }, [lastActionSuccess, modal, dispatch]);

    // Toggle modal
    const toggle = () => {
        setModal(!modal);
        if (modal) setEvaluation(null);
    };

    // Créer nouvelle évaluation
    const onClickNewEvaluation = () => {
        setIsEdit(false);
        setEvaluation(null);
        toggle();
    };

    // Edit évaluation
    const handleEvaluationClick = (evaluation) => {
        setEvaluation(evaluation);
        setIsEdit(true);
        toggle();
        dispatch(OnResetEvaluationLastActionSuccess());
    };

    // Delete évaluation
    const onClickDelete = (evaluation) => {
        setEvaluation(evaluation);
        setDeleteModal(true);
    };

    const handleDeleteAnonymousExamRecord = () => {
        if (evaluation?.id) {
            dispatch(onDeleteAnonymousExamRecord(evaluation));
            setDeleteModal(false);
        }
    };

    // 🔹 Search avec stockage des filtres
    /*const handleSearch = (newFilters) => {
        setFilters(newFilters);  // 🔹 Stocke les filtres pour l'export PDF
        dispatch(onGetAnonymousExamRecords(newFilters));
    };
    */
    const handleSearch = (newFilters) => {
        // On force l'utilisation de evaluationUuid venant de useParams()
        const updatedFilters = { 
            ...newFilters, 
            evaluation_uuid: evaluationUuid // Utilise la variable extraite de useParams
        };
        
        console.log("FILTERS SENT TO DISPATCH:", updatedFilters); // Pour debugger
        setFilters(updatedFilters);
        dispatch(onGetAnonymousExamRecords(updatedFilters));
    };

    const togglePreviewModal = () => {
        setPreviewModal(!previewModal);
    }

    const handlePreviewClick = (record) => {
        setSelectedRecord(record);
        setModalOpen(true);
    };

    // Generate all anonymous exam records
    const handleGenerateAllAnonymousRecordsPdf = async () => {
        if (!anonymousExamRecords || anonymousExamRecords.length === 0) return;

        try {
            setIsGeneratingPDF(true); // 🔹 afficher le spinner

            // Générer le PDF en mémoire avec MultipleFichesPDF
            const blob = await pdf(<MultipleFichesPDF records={anonymousExamRecords} />).toBlob();

            // Créer un lien temporaire pour le téléchargement
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "fiches_examens.pdf";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Nettoyage mémoire
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Erreur lors de la génération des fiches PDF :", error);
        } finally {
            setIsGeneratingPDF(false); // 🔹 cacher le spinner
        }
    };

    const handleGenerateAnonymousRecords = () => {
        dispatch(onGenerateAnonymousRecords(evaluationUuid));
    };

    // Colonnes du tableau
    const columns = useMemo(
            () => [
                {
                    header: 'ID',
                    accessorKey: "id",
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: (cellProps) => {
                        return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                    }
                },
                {
                    header: "Date",
                    accessorKey: "created_at",
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: (cellProps) => {
                        const dateStr = cellProps.row.original.created_at;
                        return format(dateStr, "dd/MM/yyyy", { locale: fr }); 
                    },
                    
                },
                {
                    header: "Réf. Évaluation",
                    accessorKey: "evaluation.title",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
                {
                    header: "EC",
                    accessorKey: "course_component.title",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
                {
                    header: "Matricule étudiant",
                    accessorKey: "student_number", 
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: (cellProps) => {
                        const student = cellProps.row.original.student;
                        if (!student) return "-";
                        return `${student.student_number}`;
                    },
                },
                {
                    header: "Nom et prenom",
                    accessorKey: "student", 
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: (cellProps) => {
                        const student = cellProps.row.original.student;
                        if (!student) return "-";
                        return `${student.first_name} ${student.last_name}`;
                    },
                },
                
                {
                    header: "Semestre",
                    accessorKey: "semester.code",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
                {
                    header: "Niveau d'étude",
                    accessorKey: "study_level.name",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
                {
                    header: 'Action',
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: (cellProps) => {
                        return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            <li>
                            <Button
                                color="info"
                                size="sm"
                                onClick={() => {
                                    setSelectedRecord(cellProps.row.original);
                                    setPreviewModalOpen(true); // ouvre le modal
                                }}
                            >
                                <i className="bx bx-id-card"></i> Fiche
                            </Button>
                            </li>
                        </ul>
                        );
                    }
                    },


                ],
            []
        );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteAnonymousExamRecord}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Évaluations" breadcrumbItem="Fiches anonymes" />

                    {/* 🔹 Composant de recherche */}
                    <SearchAnonymousExamRecord onSearch={handleSearch} />

                    {loading ? <Spinners setLoading={setLoading} /> :
                        <Row>
                            <Col lg="12">
                                <Card>
                                    <CardBody className="border-bottom d-flex justify-content-end align-items-center">

                                        <Button 
                                            color="info" 
                                            disabled={loading}
                                            onClick={handleGenerateAnonymousRecords}
                                            className="me-2"
                                        >
                                            {loading ? <i className="bx bx-loader bx-spin me-2"></i> : <i className="bx bx-cog me-2"></i>}
                                            Générer les fiches anonymes
                                        </Button>

                                    


                                        <Button 
                                            color="primary" 
                                            disabled={isGeneratingPDF} 
                                            onClick={handleGenerateAllAnonymousRecordsPdf}
                                            className="me-2" // petit espace entre les boutons
                                        >
                                            {isGeneratingPDF ? "Génération..." : "Afficher les fiches"}
                                        </Button>
                                        {/*<Button color="success" onClick={() => ExportPDFPro(anonymousExamRecords, filters)}>
                                            Exporter la liste des candidats
                                        </Button>
                                        */}
                                    </CardBody>
                                    <CardBody>
                                        <TableContainer
                                                columns={columns}
                                                data={anonymousExamRecords || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    }

                    {/* Modal */}
                    <EvaluationModal
                        modal={modal}
                        toggle={toggle}
                        isEdit={isEdit}
                        evaluation={evaluation}
                        courseUnits={courseUnits}
                        semesters={semesters}
                        onSubmit={(payload) => {
                            if (isEdit) {
                                dispatch(onUpdateAnonymousExamRecord(payload));
                            } else {
                                dispatch(onAddNewAnonymousExamRecord(payload));
                            }
                        }}
                    />

                </div>
            </div>
            <ToastContainer />
            <FichePreviewModal
                isOpen={previewModalOpen}
                toggle={() => setPreviewModalOpen(!previewModalOpen)}
                record={selectedRecord}
            />




        </React.Fragment>
    );
};

export default AnonymousExamRecord;
